// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `video-player .video-player-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  display: flex;
  justify-content: center;
  background: rgba(0, 0, 0, 0.8);
}
video-player .truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
video-player #video-player .video {
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
}
video-player #video-player .external-video {
  margin-top: auto;
  margin-bottom: auto;
  height: 100%;
}
video-player button.close-fullscreen {
  position: absolute;
  top: var(--safe-area-top);
  right: var(--safe-area-right);
}
video-player #image-player {
  width: 100%;
  height: 100%;
}
video-player #image-player pinch-zoom {
  width: 100%;
  height: 100%;
}
video-player #image-player pinch-zoom .pz-zoom-button {
  display: none;
}
video-player #image-player img {
  width: 100%;
}
video-player .credits {
  position: absolute;
  color: white;
  font-size: 11px;
  bottom: 4px;
  left: 4px;
  text-shadow: 0 0 2px black;
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/motes-media-player/video-player/video-player.component.scss"],"names":[],"mappings":"AAEC;EACC,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;AADF;AAIC;EACC,mBAAA;EACA,gBAAA;EACA,uBAAA;AAFF;AAOE;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AALH;AAQE;EACC,gBAAA;EACA,mBAAA;EACA,YAAA;AANH;AAUC;EACC,kBAAA;EACA,yBAAA;EACA,6BAAA;AARF;AAWC;EACC,WAAA;EACA,YAAA;AATF;AAWE;EACC,WAAA;EACA,YAAA;AATH;AAUG;EACC,aAAA;AARJ;AAYE;EACC,WAAA;AAVH;AAcC;EACC,kBAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,SAAA;EACA,0BAAA;AAZF","sourcesContent":["video-player {\n\n\t.video-player-container {\n\t\tposition: fixed;\n\t\ttop: 0;\n\t\tleft: 0;\n\t\tright: 0;\n\t\tbottom: 0;\n\t\tz-index: 20;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\tbackground: rgba(0, 0, 0, 0.8);\n\t}\n\n\t.truncate {\n\t\twhite-space: nowrap;\n\t\toverflow: hidden;\n\t\ttext-overflow: ellipsis;\n\t}\n\n\t#video-player {\n\n\t\t.video {\n\t\t\tmax-width: 100%;\n\t\t\tmax-height: 100%;\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t}\n\n\t\t.external-video {\n\t\t\tmargin-top: auto;\n\t\t\tmargin-bottom: auto;\n\t\t\theight: 100%;\n\t\t}\n\t}\n\n\tbutton.close-fullscreen {\n\t\tposition: absolute;\n\t\ttop: var(--safe-area-top);\n\t\tright: var(--safe-area-right);\n\t}\n\n\t#image-player {\n\t\twidth: 100%;\n\t\theight: 100%;\n\n\t\tpinch-zoom {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\t.pz-zoom-button {\n\t\t\t\tdisplay: none;\n\t\t\t}\n\t\t}\n\n\t\timg {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n\n\t.credits {\n\t\tposition: absolute;\n\t\tcolor: white;\n\t\tfont-size: 11px;\n\t\tbottom: 4px;\n\t\tleft: 4px;\n\t\ttext-shadow: 0 0 2px black;\n\t}\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
